import copyToClipboard from "../utilities/copyToClipboard";

const Social = () => {
    const socialEl = document.querySelector(".js-share");

    if (socialEl) {
        const popupEl = document.querySelector(".js-popup");
        const overlayEl = document.querySelector(".js-overlay");
        const CopyEl = popupEl.querySelector(".js-copy-clipboard");
        const copyText = popupEl.querySelector(".js-copy-text");
        const originalCopyText = copyText.innerHTML;

        socialEl.addEventListener("click", togglePopup);

        // copy page absolute url to clipboard
        CopyEl.addEventListener("click", () => {
            copyToClipboard(CopyEl.getAttribute("data-url"));

            // give the user some feedback that something actually happened
            copyText.innerHTML = "Copied!";

            setTimeout(() => {
                copyText.innerHTML = originalCopyText;
            }, 1000);
        });

        // close popup if user clicks outside of the popup
        overlayEl.addEventListener("click", (event) => {
            const isOutside = !event.target.closest(".share__popup");

            if (isOutside) {
                closePopup();
            }
        });

        // close popup if escape key is pressed
        window.addEventListener("keydown", (event) =>
            event.keyCode === 27 ? closePopup() : null
        );

        function togglePopup() {
            popupEl.classList.toggle("share__popup--visible");
            overlayEl.classList.toggle("share__overlay--visible");
        }

        function closePopup() {
            popupEl.classList.remove("share__popup--visible");
            overlayEl.classList.remove("share__overlay--visible");
        }
    }
};

export default Social;
